import { Component } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-instagram',
  templateUrl: './instagram.component.html',
  styleUrls: ['./instagram.component.scss'],
})
export class InstagramComponent {
  menuOpen = false;
  reviews = [
    { text: 'instagram_page.testimonials_1_text', author: 'instagram_page.testimonials_1_author' },
    { text: 'instagram_page.testimonials_2_text', author: 'instagram_page.testimonials_2_author' },
    { text: 'instagram_page.testimonials_3_text', author: 'instagram_page.testimonials_3_author' },
  ];

  toggleMenu(): void {
    this.menuOpen = !this.menuOpen;
  }

  scrollTo(id: string): void {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
    if (this.menuOpen) {
      this.toggleMenu();
    }
  }

  protected readonly environment = environment;
}
